import React, { useState, useRef } from "react";
import "../styles/Popup.css";
import FormInput from "./FormInput";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export default function Popup({
  isOpen,
  onClose,
  title,
  description,
  productId = null,
  size = null,
  reason,
}) {
  const popupRef = useRef(null);
  const [email, setEmail] = useState("");

  const handleOverlayClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }

    // API request payload
    const payload = {
      email,
      reason: reason,
      product_id: productId,
      size: size,
    };

    try {
      // Make POST request to the API
      const response = await fetch(`${apiUrl}/ct/add/email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-App-Secret": process.env.REACT_APP_APP_SECRET,
        },
        body: JSON.stringify(payload),
      });

      // Check for HTTP errors
      if (!response.ok) {
        const errorData = await response.json();
        // Directly show the message provided by the API (e.g., the duplicate message)
        alert(errorData.message || "Failed to submit email.");
        return;
      }

      // Parse the response JSON
      const responseData = await response.json();

      // Handle success
      alert("Thank you! You have been added to the email list.");
      console.log("API Response:", responseData);

      // Clear the email field and close the popup
      setEmail("");
      onClose();
    } catch (error) {
      // Handle errors
      console.error("Error submitting email:", error);
      alert(`An error occurred: ${error.message}`);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-content" ref={popupRef}>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h2 className="popup-title">{title}</h2>
        <p className="popup-description">{description}</p>
        <form className="popup-form" onSubmit={handleSubmit}>
          <FormInput
            label="Email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            rows={1}
            required
          />
          <button type="submit" className="popup-submit">
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
}
